import React from 'react'
import { Path } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'

import { AccessibleIcon } from './types'

const BookingSvg: React.FunctionComponent<AccessibleIcon> = ({
  size,
  color,
  accessibilityLabel,
  testID,
}) => (
  <AccessibleSvg
    width={size}
    height={size}
    viewBox="0 0 49 49"
    accessibilityLabel={accessibilityLabel}
    testID={testID}>
    <Path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.91553 12.14C4.91553 10.0359 6.43939 8.50024 8.11514 8.5L33.2547 8.52C33.807 8.52044 34.2551 8.07308 34.2555 7.5208C34.256 6.96851 33.8086 6.52044 33.2563 6.52L8.11553 6.5C5.15143 6.5 2.91553 9.12423 2.91553 12.14V16.61C2.91553 17.9564 3.82003 19.1174 5.09257 19.4891C7.00609 20.0615 8.51553 22.0387 8.51553 24.5C8.51553 26.9614 7.00595 28.9387 5.0923 29.5109C3.8228 29.8819 2.91553 31.0308 2.91553 32.39V36.86C2.91553 39.8758 5.15143 42.5 8.11553 42.5H41.7155C44.6796 42.5 46.9155 39.8758 46.9155 36.86V32.39C46.9155 31.0438 46.0112 29.8828 44.7388 29.511C42.8251 28.9387 41.3155 26.9614 41.3155 24.5C41.3155 22.0365 42.8169 20.0613 44.7379 19.4893C46.0079 19.1186 46.9155 17.9695 46.9155 16.61V12.14C46.9155 9.12423 44.6796 6.5 41.7155 6.5C41.1632 6.5 40.7155 6.94772 40.7155 7.5C40.7155 8.05228 41.1632 8.5 41.7155 8.5C43.3914 8.5 44.9155 10.0358 44.9155 12.14V16.61C44.9155 17.0493 44.6247 17.4394 44.1764 17.5697L44.1708 17.5714C41.313 18.4204 39.3155 21.2445 39.3155 24.5C39.3155 27.7574 41.3246 30.5795 44.1697 31.4283L44.1764 31.4302C44.6218 31.5597 44.9155 31.9577 44.9155 32.39V36.86C44.9155 38.9642 43.3914 40.5 41.7155 40.5H8.11553C6.43962 40.5 4.91553 38.9642 4.91553 36.86V32.39C4.91553 31.9507 5.20632 31.5606 5.65468 31.4303L5.6614 31.4283C8.50649 30.5795 10.5155 27.7574 10.5155 24.5C10.5155 21.2426 8.5065 18.4205 5.6614 17.5717L5.65467 17.5697C5.20922 17.4403 4.91553 17.0423 4.91553 16.61V12.14ZM29.9155 16.53C29.9155 15.9777 29.4678 15.53 28.9155 15.53C28.3632 15.53 27.9155 15.9777 27.9155 16.53V32.58C27.9155 33.1323 28.3632 33.58 28.9155 33.58C29.4678 33.58 29.9155 33.1323 29.9155 32.58V16.53Z"
    />
  </AccessibleSvg>
)

export const Booking = styled(BookingSvg).attrs(({ color, size, theme }) => ({
  color: color ?? theme.designSystem.color.icon.default,
  size: size ?? theme.designSystem.size.icon.l,
}))``
